const labels = [
  {
    keyindex: 0,
    value: "Vistar",
    label: "Vistar",
  },
  {
    keyindex: 0,
    value: "PlaceExchange",
    label: "PlaceExchange",
  },
];

module.exports = { data: labels };
